<template>
  <div>
    <BaseButton
      class="bg-white inline-flex justify-center items-center w-full"
      data-calendar-button
      type="button"
      @click="focusCalendar"
    >
      <img class="w-[2.4rem]" src="@/assets/images/Calendar.svg" alt="">
      <span class="text-black mr-4">{{ $t('Starting from') }}</span>
      <flat-pickr
        class="calendar-button-flat-pickr"
        v-model="date"
        @on-change="onChange"
        :config="flatPickrConfig"
      />
      <img src="@/assets/images/down_arrow.svg" alt="">
    </BaseButton>
  </div>
</template>

<script>

import { defineComponent } from 'vue';
import BaseButton from '@/components/buttons/baseButton.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default defineComponent({
  name: 'CalendarButton',
  components: {
    BaseButton,
    flatPickr
  },
  props: {
    useHour: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Date,
      default: () => new Date()
    }
  },
  data() {
    return {
      date: new Date(),
      pickerInstance: null
    };
  },
  computed: {
    flatPickrConfig() {
      const dateFormat = this.useHour ? this.$t('dateTimeFormat') : this.$t('dateFormat');
      return {
        wrap: true,
        dateFormat,
        altFormat: dateFormat,
        enableTime: this.useHour,
        time_24hr: true,
        allowInput: false,
        minDate: 'today',
        onReady: (_, __, instance) => {
          this.pickerInstance = instance;
        }
      };
    }
  },
  watch: {
    modelValue: {
      handler(newVal) {
        if (newVal && newVal instanceof Date && (!this.date || !(this.date instanceof Date) || newVal.getTime() !== this.date.getTime())) {
          this.date = newVal;
        }
      },
      immediate: true
    }
  },
  methods: {
    focusCalendar() {
      if (this.pickerInstance && typeof this.pickerInstance.open === 'function') {
        this.pickerInstance.open();
        return;
      }

      const button = this.$el?.querySelector?.('[data-calendar-button]');
      if (!button) {
        return;
      }

      const input = button.querySelector('input.calendar-button-flat-pickr');
      if (input && typeof input._flatpickr?.open === 'function') {
        input._flatpickr.open();
        return;
      }

      if (input) {
        input.dispatchEvent(new Event('focus'));
      }
    },
    onChange(selectedDates) {
      const selectedDate = selectedDates[0];
      if (selectedDate && selectedDate instanceof Date) {
        if (!this.date || !(this.date instanceof Date) || selectedDate.getTime() !== this.date.getTime()) {
          this.date = selectedDate;
          this.$emit('update:modelValue', selectedDate);
        }
      }
    }
  },
  emits: ['update:modelValue']
});
</script>

<style scoped></style>
